import { useMemo } from "react";
import { useMyPermissions } from "@/features/permissions/hooks/usePermissionsQueries";

export function useContentPermissions() {
  const { data, isLoading } = useMyPermissions();
  const permissions = useMemo(() => new Set(data?.permissions ?? []), [data]);

  return {
    isLoading,
    /*
     * 🔑 THE PERMISSION, NOT THE ROLE (changed 2026-08-24).
     * ⚠️ THIS WAS `isSuperAdmin(user)`, AND IT WAS THE CLIENT HALF OF A PERMISSION THAT MEANT
     * NOTHING. The backend's POST /content/:contentType matched it with its own hard role check, so
     * `content:create-draft` — tickable per role and per user, and in the EDITOR baseline — granted
     * no reachable capability on either side. The endpoint is now governed by that permission
     * (content.ts create, scoped with assertDepartmentIdAllowed), so this must ask the same
     * question or the button stays hidden from exactly the people who were just granted it.
     * A super admin still sees it: effective-permissions resolves SUPER_ADMIN to the whole
     * catalogue, so the permission is present for them without a special case here.
     */
    canCreatePage: permissions.has("content:create-draft"),
    canReview: permissions.has("content:review"),
    canApprove: permissions.has("content:approve"),
    canPublish: permissions.has("content:publish"),
    canDeleteDraft: permissions.has("content:delete-draft"),
    canViewAnalytics: permissions.has("system:view-analytics"),
  };
}
